<template>
    <framed-layout>

        <template #center>
            <h3 class="font-bold">Registreeru kasutajaks</h3>
        </template>

        <template #right>
            <a @click="$router.go(-1)" class="btn-circle cursor-pointer">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </a>
        </template>

        <div class="max-w-4xl mx-auto">
            <h1 class="text-2xl font-bold leading-tight text-center md:text-4xl lg:text-5xl">
                Vali autentimismeetod
            </h1>

            <div class="my-8 md:my-16">
                <authentication-methods ref="auth-methods" :message="message" :method="method" @success="success($event)" :isLogin="false"/>
            </div>

            <div class="flex flex-col items-center">
                <button
                    @click="register"
                    :class="{ 'opacity-50 pointer-events-none': !selected }"
                    class="w-56 text-white bg-orange-400 btn"
                >Jätka
                </button>
                <router-link to="/login" class="mt-5 text-sm font-semibold uppercase hover:underline"
                >Mul on konto olemas
                </router-link>
            </div>

            <keyboard-events v-on:keyup="keyboardEvent"></keyboard-events>

        </div>
    </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import {getChallenge, getToken, login} from "@/store/login.api";
import * as webeid from '@web-eid/web-eid-library/web-eid';
import AuthService from "@/services/auth.service";

export default {
    props: ['message', 'method'],
    components: {
        FramedLayout
    },
    metaInfo: {
      title: 'Registreeri kasutajaks',
      meta: [
        { property: 'og:title', content: 'Registreeri kasutajaks' },
        { property: 'robots', content: 'index, follow' },
      ]
    },
    data() {
        return {
            selected: null
        }
    },
    methods: {
        async register() {
            try {
                this.message = '';
                const payload = this.$refs['auth-methods'].selection;

                if(payload?.selected === 3) {
                  await getChallenge().then(async (resp) => {
                    const challengeNonce = resp.data.base64EncodedNonce;
                    const token = resp.data.token;
                    await webeid.authenticate(challengeNonce, {lang: "et"}).then(async (authToken) => {
                      const req = {
                        token: token,
                        role: this.$route.query?.selected,
                        webEidAuthToken: authToken,
                        referral: this.$route.query?.referral
                      };
                      await login(req).then((resp) => {
                        AuthService.login(resp.data?.token);
                        if (resp.data?.isNewUser) {
                          this.$router.push('/terms-of-use/accept');
                        } else {
                          this.$router.push('/projects');
                        }
                      }, (error) => {
                        const toast = error.response?.data;
                        if (toast) {
                          this.processAxiosPositiveResponse(toast);
                        }
                      });
                    });
                  });
                } else {
                  const { data } = await getToken(payload);
                  if(data?.message) {
                    this.message = data.message;
                  } else {
                    this.$router.push({
                      path: '/code',
                      query: {
                        verificationCode: data?.verificationCode,
                        authenticationHash: data?.authenticationHash,
                        role: this.$route.query?.selected,
                        referral: this.$route.query?.referral,
                        ...payload,
                      },
                    });
                  }
                }
            } catch (e) {
                console.error(e);
            }
        },
        success(e) {
            this.selected = e
        },
        keyboardEvent (e) {
          if (e.which === 13 && this.selected) {
            this.register();
          }
        }
    },
    mounted() {
        if (this.$route.query?.message) {
            this.message = this.$route.query.message;
        }
    },
}
</script>
